import Axios from 'axios'
import React, { Component } from 'react'
import { Segment, Table, Icon, Button } from 'semantic-ui-react';

import RatechartModal from './rateChartModal';
import _ from 'lodash';
import { LOCAL_STORAGE } from '../../../utils/constant';
import cogoToast from 'cogo-toast';

const lengthArray = {};
export default class RateChart extends Component {
	state = {
		open: false,
		rate_chart: [],
		isEdit: false,
		editData: null,
		consigneeList: [],
		vehicalList: [],
		vendorList: [],
		routeList: [],
		billingPartyList: [],
		lineItemList: [],
		operationalTypeList: [],
		containerTypeList: [],
		unitOfMeasurementList: [],
		consignorList: [],
		branchList: [],
		loadTypeList: [],
		tripTypeList: [],
		movementTypeList: [],
	}
	handleClose = () => {
		this.setState({ open: false, editData: null })
	}
	handleUpdate = (data) => {
		if (data) {
			this.setState({ open: false })
			this.getMasterData()
		}
	}
	handleOpen = () => {
		this.setState({ open: true })
	}


	componentDidMount() {
		this.getMasterData();
		this.getAllData();
	};

	rateChartEdit = (object) => {
		this.setState({
			open: !this?.state?.open || false,
			isEdit: true,
			editData: object
		});
	}
	getMasterData = () => {
		const congData = {
			customerNo: LOCAL_STORAGE.customerNo,
			userId: LOCAL_STORAGE.userId,
			engineTypeId: 2,
			vendorId: this?.props?.vendorCode || 0
		};

		Axios.post(`${process.env.REACT_APP_MASTER_API}/rateEngine/fetch`, congData, { headers: { 'content-type': 'application/json', 'Authorization': `${LOCAL_STORAGE.userToken}` } }).then((response) => {
			if (response.status === 200) {
				this.setState({
					rate_chart: response.data.resultSet
				})
			}
		})
	};

	getAllData = () => {
		const apiPayload = {
			customerNumber: LOCAL_STORAGE.customerNo,
			customer_no: LOCAL_STORAGE.customerNo,
			user_id: LOCAL_STORAGE.userId,
			customerNo: LOCAL_STORAGE.customerNo,
			userId: LOCAL_STORAGE.userId,
		};

		Axios.post(`${process.env.REACT_APP_MASTER_API}/consigneeMaster`, apiPayload, { headers: { 'content-type': 'application/json', 'Authorization': `${LOCAL_STORAGE.userToken}` } })
			.then(response => {
				if (response.status === 200 && response.data.resultSet !== "") {
					const tempData = response.data.resultSet.map(e => {
						return {
							key: e.consigneeId,
							label: e.consigneeName,
							value: e.consigneeCode
						}
					});
					lengthArray.consigneeListLength = tempData.length;
					this.setState({ consigneeList: tempData });
				}
			})
			.catch(err => console.log(err));

		Axios.post(`${process.env.REACT_APP_MASTER_API}/transporterMaster`, apiPayload, { headers: { 'content-type': 'application/json', 'Authorization': `${LOCAL_STORAGE.userToken}` } })
			.then(response => {
				if (response.status === 200 && response.data.resultSet !== "") {
					const tempData = response.data.resultSet.map(e => {
						if (e.transporterMasterId === this?.props?.history?.location?.state?.transporterMasterId) {
							return {
								key: e.transporterMasterId,
								text: e.transporterName,
								value: e.transporterMasterId.toString()
							}
						}
					});
					lengthArray.vendorListLength = tempData.length;
					this.setState({ vendorList: tempData.filter(Boolean) });
				}
			})
			.catch(err => console.log(err));

		Axios.post(`${process.env.REACT_APP_MASTER_API}/routeMaster`, apiPayload, { headers: { 'content-type': 'application/json', 'Authorization': `${LOCAL_STORAGE.userToken}` } })
			.then(response => {
				if (response.status === 200 && response.data.resultSet !== "") {
					const tempData = response.data.resultSet.map(object => {
						return {
							key: object.routeMasterId,
							label: object.routeName,
							value: object.routeMasterId
						}
					});
					lengthArray.routeListLength = tempData.length;
					this.setState({ routeList: tempData });
				}
			})
			.catch(err => console.log(err));

		Axios.post(`${process.env.REACT_APP_MASTER_API}/vehicleTypeMaster`, apiPayload, { headers: { 'content-type': 'application/json', 'Authorization': `${LOCAL_STORAGE.userToken}` } })
			.then(response => {
				if (response.status === 200 && response.data.resultSet !== "") {
					const tempData = response.data.resultSet.map(object => {
						return {
							key: object.vehicleTypeId,
							label: object.vehicleType,
							value: object.vehicleTypeId
						}
					});
					lengthArray.vehicalListLength = tempData.length;
					this.setState({ vehicalList: tempData });
				}
			})
			.catch(err => console.log(err));

		Axios.get(`${process.env.REACT_APP_MASTER_API}/billing_party?customerNumber=${apiPayload.customerNumber}&userId=${apiPayload.userId}`, { headers: { 'content-type': 'application/json', 'Authorization': `${LOCAL_STORAGE.userToken}` } })
			.then(response => {
				if (response.status === 200 && response.data.resultSet !== "") {
					const tempData = response.data.resultSet.map(object => {
						return {
							key: object.billingPartyId,
							label: object.billingPartyName,
							value: object.billingPartyId
						}
					});
					lengthArray.billingPartyListLength = tempData.length;
					this.setState({ billingPartyList: tempData })
				}
			})
			.catch(err => console.log(err));

		Axios.get(`${process.env.REACT_APP_MASTER_API}/psLineItem?customerNumber=${apiPayload.customerNumber}&userId=${apiPayload.userId}`, { headers: { 'content-type': 'application/json', 'Authorization': `${LOCAL_STORAGE.userToken}` } })
			.then(response => {
				if (response.status === 200 && response.data.resultSet !== "") {
					let tempData = response.data.resultSet.map(object => {
						return {
							key: object.psId,
							text: object.psDescription,
							value: object.psId
						}
					});
					tempData = _.uniqBy(tempData, 'key');
					lengthArray.lineItemListLength = tempData.length;
					this.setState({ lineItemList: tempData })
				}
			})
			.catch(err => console.log(err));

		Axios.get(`${process.env.REACT_APP_MASTER_API}/orderType/0?customerNo=${apiPayload.customerNumber}&userId=${apiPayload.userId}`, { headers: { 'content-type': 'application/json', 'Authorization': `${LOCAL_STORAGE.userToken}` } })
			.then(response => {
				if (response.status === 200 && response.data.resultSet !== "") {
					const tempData = response.data.resultSet.map(object => {
						return {
							key: object.orderTypeMasterId,
							text: object.orderType,
							value: object.orderTypeMasterId
						}
					});
					lengthArray.operationalTypeListLength = tempData.length;
					this.setState({ operationalTypeList: tempData })
				}
			})
			.catch(err => console.log(err));

		Axios.get(`${process.env.REACT_APP_MASTER_API}/container_type?customerNumber=${apiPayload.customerNumber}&userId=${apiPayload.userId}`, { headers: { 'content-type': 'application/json', 'Authorization': `${LOCAL_STORAGE.userToken}` } })
			.then(response => {
				if (response.status === 200 && response.data.resultSet !== "") {
					const tempData = response.data.resultSet.map(object => {
						return {
							key: object.containerTypeId,
							label: object.containerType,
							value: object.containerTypeId
						}
					});
					lengthArray.containerTypeListLength = tempData.length;
					this.setState({ containerTypeList: tempData })
				}
			})
			.catch(err => console.log(err));

		Axios.post(`${process.env.REACT_APP_MASTER_API}/unitOfMeasurement`, apiPayload, { headers: { 'content-type': 'application/json', 'Authorization': `${LOCAL_STORAGE.userToken}` } })
			.then(response => {
				if (response.status === 200 && response.data.resultSet !== "") {
					const tempData = response.data.resultSet.map(object => {
						return {
							key: object.uomId,
							text: object.unit,
							value: object.uomId
						}
					});
					lengthArray.unitOfMeasurementListLength = tempData.length;
					this.setState({ unitOfMeasurementList: tempData })
				}
			})
			.catch(err => console.log(err));

		Axios.post(`${process.env.REACT_APP_MASTER_API}/consignorMaster`, apiPayload, { headers: { 'content-type': 'application/json', 'Authorization': `${LOCAL_STORAGE.userToken}` } })
			.then(response => {
				if (response.status === 200 && response.data.resultSet !== "") {
					const tempData = response.data.resultSet.map(e => {
						return {
							key: e.consignorId,
							label: e.consignorName,
							value: e.consignorCode
						}
					});
					lengthArray.consignorListLength = tempData.length;
					this.setState({ consignorList: tempData })
				}
			})
			.catch(err => console.log(err));

		Axios.post(`${process.env.REACT_APP_MASTER_API}/branch`, apiPayload, { headers: { 'content-type': 'application/json', 'Authorization': `${LOCAL_STORAGE.userToken}` } })
			.then(response => {
				if (response.status === 200 && response.data.resultSet !== "") {
					const tempData = response.data.resultSet.map(e => {
						return {
							key: e.branchId,
							label: e.branchName,
							value: e.branchId
						}
					});
					lengthArray.branchListLength = tempData.length;
					this.setState({ branchList: tempData })
				}
			})
			.catch(err => console.log(err));

		Axios.get(`${process.env.REACT_APP_TA_API_URL}/orders/masters/load/type`, { headers: { 'content-type': 'application/json', 'Authorization': `${LOCAL_STORAGE.userToken}` } })
			.then(response => {
				if (response.status === 200 && response.data.data !== "") {
					const tempData = response.data.data.map(object => {
						return {
							key: object.load_type_id,
							text: object.load_type_name,
							value: object.load_type_id
						}
					});
					lengthArray.loadTypeListLength = tempData.length;
					this.setState({ loadTypeList: tempData })
				}
			})
			.catch(err => console.log(err));

		Axios.get(`${process.env.REACT_APP_MASTER_API}/tripType/0?customerNo=${apiPayload.customerNumber}&userId=${apiPayload.userId}`, { headers: { 'content-type': 'application/json', 'Authorization': `${LOCAL_STORAGE.userToken}` } })
			.then(response => {
				if (response.status === 200 && response.data.resultSet !== "") {
					const tempData = response.data.resultSet.map(object => {
						return {
							key: object.tripTypeMasterId,
							text: object.tripType,
							value: object.tripTypeMasterId
						}
					});
					lengthArray.tripTypeListLength = tempData.length;
					this.setState({ tripTypeList: tempData })
				}
			})
			.catch(err => console.log(err));

		Axios.get(`${process.env.REACT_APP_MASTER_API}/movementType/0?customerNo=${apiPayload.customerNumber}&userId=${apiPayload.userId}`, { headers: { 'content-type': 'application/json', 'Authorization': `${LOCAL_STORAGE.userToken}` } })
			.then(response => {
				if (response.status === 200 && response.data.resultSet !== "") {
					const tempData = response.data.resultSet.map(object => {
						return {
							key: object.movementTypeId,
							text: object.movementType,
							value: object.movementTypeId
						}
					});
					lengthArray.movementTypeListLength = tempData.length;
					this.setState({ movementTypeList: tempData })
				}
			})
			.catch(err => console.log(err));
	};

	onDeletePress(rateEngineId) {
		const data = {
			customerNo: LOCAL_STORAGE.customerNo,
			userId: LOCAL_STORAGE.userId,
			rateEngineId: rateEngineId
		};

		Axios.delete(`${process.env.REACT_APP_MASTER_API}/rateEngine/delete`, { data: data, headers: { 'content-type': 'application/json', 'Authorization': `${LOCAL_STORAGE.userToken}` } })
			.then(res => {
				if (res.status === 200) {
					cogoToast.success('Rate chart Deleted');
					this.getMasterData();
				}
			})
			.catch(err => {
				cogoToast.error('Something went wrong!');
				console.log(err);
			})
	};

	clearData = () => {
		this.setState({
			isEdit: false,
		})
	};

	render() {
		return (
			<Segment className="w3-small">
				<Table>
					<Table.Header>
						<Table.Row>
							<Table.HeaderCell colSpan="7">Rate Chart</Table.HeaderCell>
							<Table.HeaderCell className="text-right">
								<Button className="w3-blue w3-tiny w3-hover-blue" onClick={this.handleOpen}><i className="fa fa-plus"></i> New</Button>
							</Table.HeaderCell>
						</Table.Row>
					</Table.Header>
					<Table.Header>
						<Table.Row>
							<Table.HeaderCell>Source</Table.HeaderCell>
							<Table.HeaderCell>Destination</Table.HeaderCell>
							<Table.HeaderCell>Vehicle Type</Table.HeaderCell>
							<Table.HeaderCell>Start Date</Table.HeaderCell>
							<Table.HeaderCell>End Date</Table.HeaderCell>
							<Table.HeaderCell>Edit</Table.HeaderCell>
							<Table.HeaderCell>Delete</Table.HeaderCell>
						</Table.Row>
					</Table.Header>
					<Table.Body>
						{this.state.rate_chart.length > 0 ?
							this.state.rate_chart.map((object, index) => (
								<Table.Row>
									<Table.Cell>{object.consignor}</Table.Cell>
									<Table.Cell>{object.consignee}</Table.Cell>
									<Table.Cell>{object.vehicleType}</Table.Cell>
									<Table.Cell>{object.startDate}</Table.Cell>
									<Table.Cell>{object.endDate}</Table.Cell>
									<Table.Cell>
										<Button
											className="ui blue"
											// style={{ marginRight: "5px" }}
											type="submit"
											basic
											size="medium"
											icon
											onClick={() => this.rateChartEdit(object)}
										>
											<Icon name="edit" />
										</Button>
									</Table.Cell>
									<Table.Cell>
										<Button onClick={() => this.onDeletePress(object.rateEngineId)} size="sm" variant="outline-danger">
											<i className="fa fa-trash" />
										</Button>
									</Table.Cell>
								</Table.Row>
							)) : <Table.Row>
								<Table.Cell colSpan="8" textAlign="center">No Record Found</Table.Cell>
							</Table.Row>}
					</Table.Body>
				</Table>
				{
					this.state.open ?
						<RatechartModal
							{...this.props}
							lengthArray={lengthArray}
							state={this.state}
							vendorId={this?.props?.location?.state?.vendorId}
							isEdit={this.state.isEdit}
							editData={this.state.editData}
							branchModal={this.state.open}
							update={this.handleUpdate}
							CloseModal={this.handleClose}
							clearData={this.clearData} />
						: null
				}
			</Segment>
		)
	}
}
